let Variable = new Object()
Variable.pageData = () => {
    return {
        total: 0,
        pageno: 1, // 当前页
        pagesize: 10, // 当前条数
        pagesizeList: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100]
    }
}

Variable.formatDate = (dateStr) => {
    if (!dateStr) return "";
    return dateStr.length > 10 ? dateStr.substr(0, 10) : dateStr;
}

Variable.trim = (value) => {
    return value.replace(/^\s+|\s+$/g, '');
}

Variable.documentTitleSuffix = '-河南省药品评审查验中心';
// 输入的最大长度

Variable.inputMax = 50

Variable.exprs = {
    htmlTags: /<[^>]+>|\t|　/gi,
    brackets: /（^[）]+）/gi
}

Variable.validators = {
    checkEmail: (rule, value, callback) => {
        if (!/^[a-zA-Z0-9_-]+@\w+(\.[a-zA-Z0-9_-]+)+$/.test(value)) {
            return callback(new Error("邮箱格式有误"));
        }
        return callback();
    },
    checkMobile: (rule, value, callback) => {
        if (!/^[0-9]{11}$/.test(value)) {
            return callback(new Error("手机号码格式有误"));
        }
        return callback();
    },
    checkPhone: (rule, value, callback) => {
        if (!/^[0-9]{5,12}$/.test(value)) {
            return callback(new Error("电话格式有误"));
        }
        return callback();
    }
};

Variable.specialIds = {
    companyUser: '1563059092496519170',
    personalUser: '1563059009554157570',
    customerDepartment: '1563108050824482817',
    businessDepartment: 'e4a3376bacc54ae29353bcf5f90c0c8c',
    firstDepartment: 'a120f46cfb054febb056bd8665f2db85',
    secondDepartment: '5ef9ef5dfde24aff8884a4b3dcb79e3f',
    actionDepartments() {
        return [this.businessDepartment, this.firstDepartment, this.secondDepartment]
    },
    examineDepartments() {
        return [this.firstDepartment, this.secondDepartment]
    }
};
Variable.replaceHtmlTags = (value) => {
    if (!value) return "";
    value = value.replace(/<[^>]+>|\t|　/gi, "");
    return value.length > 200 ? value.substr(0, 200) + "..." : value;
};

Variable.uploadUrl = process.env.VUE_APP_UPLOAD_PATH;
Variable.filePath = process.env.VUE_APP_FILE_PATH;

export default Variable